"use client";

import { CheckCircle2, XCircle } from "lucide-react";
import { useSelector } from "react-redux";
import Lang from "../../config/lang";

export default function SuccessPage({ status = "finished" }) {
    const { lang } = useSelector((state) => state.globalReducer);
    const isExpired = status === "expired";
    const isCompleted = status === "completed";
    const isFinished = !isExpired && !isCompleted;
    const title = isExpired
        ? Lang(lang, "pretest_expired_title")
        : isCompleted
            ? Lang(lang, "pretest_already_completed_title")
            : Lang(lang, "pretest_finished_title");
    const description = isExpired
        ? Lang(lang, "pretest_expired_desc")
        : isCompleted
            ? Lang(lang, "pretest_already_completed_desc")
            : Lang(lang, "pretest_finished_desc");

    return (
        <div className="min-h-screen w-full bg-white py-16 flex justify-center items-center">
            <div className="max-w-3xl w-full px-6 mb-[80px]">

                <div className="flex flex-col bg-white rounded-xl shadow-lg border border-[#E5E7EB] p-8 items-center">
                    {isFinished ? (
                        <img
                            src="/asset/images/assessment_successful.svg"
                            alt="assessment successful"
                        />
                    ) : (
                        <div
                            className={`flex h-20 w-20 items-center justify-center rounded-full ${
                                isExpired ? "bg-[#FEF2F2]" : "bg-[#ECFDF5]"
                            }`}
                        >
                            {isExpired ? (
                                <XCircle className="h-12 w-12 text-[#EA2427]" />
                            ) : (
                                <CheckCircle2 className="h-12 w-12 text-[#16A34A]" />
                            )}
                        </div>
                    )}
                    <h1 className="text-[24px] md:text-[32px] font-bold text-gray-900 mt-5 text-center">
                        {title}
                    </h1>
                    <div className="w-full border-b border-[#E0E5EB] my-5" />

                    <p className="text-center text-gray-700">{description}</p>

                    {!isExpired ? (
                        <div className="bg-[#16A2490D] p-5 w-full rounded-lg border border-[#16A24933] mt-5">
                            <h4 className="text-center">
                                {isCompleted
                                    ? Lang(lang, "pretest_already_completed_hint")
                                    : Lang(lang, "pretest_finished_hint")}
                            </h4>
                        </div>
                    ) : null}

                    <div className="w-full border-t border-[#E0E5EB] my-5" />
                    <p className="text-center">
                        {Lang(lang, "pretest_portal_note")}{" "}
                        <a
                            href="https://portal.solusi-pack.com/id"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline text-blue-600 hover:text-blue-800"
                        >
                            portal.solusi-pack.com
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
}
